import { ArrowUpRight } from "lucide-react";
import { trackClick } from "../lib/track";

export const AffiliateButton = ({ href, children, variant = "primary", className = "", testId }) => {
  const isNord = typeof href === "string" && href.includes("trvid=56096");
  const base =
    "group inline-flex items-center justify-center gap-2 font-display font-bold tracking-tight transition-[background-color,box-shadow,transform] duration-200 focus:ring-2 focus:ring-[#4687FF] focus:outline-none";
  const variants = {
    primary:
      "bg-[#4687FF] text-white hover:bg-[#2563eb] px-7 py-3.5 text-sm sm:text-base",
    dark: "bg-[#0F172A] text-white hover:bg-[#1e293b] px-7 py-3.5 text-sm sm:text-base",
    outline:
      "border-2 border-[#0F172A] text-[#0F172A] hover:bg-[#0F172A] hover:text-white px-6 py-3 text-sm",
    ghost:
      "text-[#4687FF] hover:text-[#2563eb] underline underline-offset-4 text-sm font-semibold",
  };
  const nordGlow =
    isNord && variant !== "ghost"
      ? "shadow-[0_8px_28px_rgba(70,135,255,0.45)] ring-1 ring-[#7EAAFF]/50 hover:-translate-y-0.5 hover:shadow-[0_14px_40px_rgba(70,135,255,0.65)]"
      : "";
  return (
    <a
      href={href}
      target="_blank"
      rel="nofollow sponsored noopener"
      data-testid={testId}
      onClick={() => trackClick(href, testId)}
      className={`${base} ${variants[variant]} ${nordGlow} ${className}`}
    >
      {children}
      <ArrowUpRight
        size={18}
        className="transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
      />
    </a>
  );
};

export const ScoreBadge = ({ score, size = "md", dark = false }) => {
  const sizes = { sm: "h-12 w-12 text-sm", md: "h-16 w-16 text-lg", lg: "h-24 w-24 text-3xl" };
  return (
    <div
      data-testid="score-badge"
      className={`flex flex-col items-center justify-center rounded-full font-display font-extrabold shrink-0 ${sizes[size]} ${
        dark ? "bg-white text-[#0F172A]" : "bg-[#4687FF] text-white"
      }`}
    >
      <span className="leading-none">{score}</span>
      {size !== "sm" && <span className="text-[9px] font-semibold opacity-70 leading-none mt-0.5">/ 10</span>}
    </div>
  );
};
